import React from "react"
import { SessionTimeoutTimerDialog } from "./components"
import { useSessionManage } from "./hooks"

interface Props {
  isAuthed: boolean
}

const SessionTimeoutTimer: React.FC<Props> = ({ isAuthed }) => {
  const {
    loading,
    openLogOutTimer,
    logOutTimerDuration,
    onLogOut,
    onContinue,
    onLogOutTimerComplete
  } = useSessionManage(isAuthed)

  return (
    !!openLogOutTimer && (
      <SessionTimeoutTimerDialog
        time={logOutTimerDuration}
        logOutLoading={loading.logOutLoading}
        onLogOut={onLogOut}
        onContinue={onContinue}
        onTimerComplete={onLogOutTimerComplete}
      />
    )
  )
}

export default SessionTimeoutTimer
